import { Component } from '@angular/core';
import { Observable } from 'rxjs';
import { UserStore, UserState } from '../../../store/user.store';
import { environment } from '../../../../environments/environment';

@Component({
  selector   : 'app-loyalty-info',
  templateUrl: './loyalty-info.component.html',
  styleUrls  : ['./loyalty-info.component.scss'],
})
export class LoyaltyInfoComponent {

  user$: Observable<UserState | null>;
  // SSO link za prijavu (guest -> WordPress login -> svez token).
  ssoUrl = environment.wordpressSiteUrl + 'fotoblic-sso';

  constructor(private userStore: UserStore) {
    this.user$ = this.userStore.user$;
  }

}
